import { useCallback, useEffect, useState } from 'react';
import { AppState } from 'react-native';

const useAppVisibility = (): boolean => {
  const [isHidden, setIsHidden] = useState<boolean>(false);

  const handleAppStateChange = useCallback((nextAppState) => {
    setIsHidden(nextAppState === 'background');
  }, []);

  useEffect(() => {
    const subscription = AppState.addEventListener(
      'change',
      handleAppStateChange,
    );

    return () => {
      subscription?.remove();
    };
  }, [handleAppStateChange]);

  return isHidden;
};

export default useAppVisibility;
